module.exports = __webpack_public_path__ + "img/background.431f8a71.jpg";